import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { WorkflowBuilder } from '../platform/WorkflowBuilder/WorkflowBuilder';
export function WorkflowBuilderSection() {
  return <section aria-labelledby="builder-heading" className="border-b border-hairline-soft bg-surface" data-id="element-396" data-mp="19w95lvh0ei8y">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-20 sm:px-6 lg:px-8 lg:py-28" data-id="element-397" data-mp="1euu8y3rk5i1m">
        <SectionHeading eyebrow="Workflow builder" headingId="builder-heading" title="Turn Your Existing Process Into an Agentic Workflow." description="Define the stages you already run. Then add agents, requirements, reviewers, approvals, documents and conditions to each one." data-id="element-398" data-mp="106ft8s91lz3n" />
        <Reveal className="mt-12" data-id="element-399" data-mp="w3jh9ke0d18o">
          <WorkflowBuilder data-id="element-400" data-mp="h8mywechixhv" />
        </Reveal>
      </div>
    </section>;
}